import dayjs from "dayjs"
import { DataPlanModel, GroupModel, Member, OrganizationType, TerminalDataModel } from "./models"
import { Receipt } from "../components/organisms/ReceiptsCard"
import isBetween from "dayjs/plugin/isBetween"
dayjs.extend(isBetween)

//Filter members
export const filterMemberNameZtoA = (members: Array<Member>) => {
  const sortedList = members.slice().sort((a, b) => {
    const aName = a?.member?.name ?? ""
    const bName = b?.member?.name ?? ""

    return bName.localeCompare(aName)
  })

  return sortedList
}
export const filterMemberNameAtoZ = (members: Array<Member>) => {
  const sortedList = members.slice().sort((a, b) => {
    const aName = a?.member?.name ?? ""
    const bName = b?.member?.name ?? ""

    return aName.localeCompare(bName)
  })

  return sortedList
}
export const filterMemberTitleAtoZ = (members: Array<Member>) => {
  const sortedList = members.slice().sort((a, b) => {
    const aName = a?.member?.title ?? ""
    const bName = b?.member?.title ?? ""

    return bName.localeCompare(aName)
  })

  return sortedList
}
export const filterMemberTitleZtoA = (members: Array<Member>) => {
  const sortedList = members.slice().sort((a, b) => {
    const aName = a?.member?.title ?? ""
    const bName = b?.member?.title ?? ""

    return aName.localeCompare(bName)
  })

  return sortedList
}

//Filter groups
export const filterGroupsNameZtoA = (groups: Array<GroupModel>) => {
  const sortedList = groups.slice().sort((a, b) => {
    const aName = a?.groupName
    const bName = b?.groupName

    return bName.localeCompare(aName)
  })

  return sortedList
}
export const filterGroupsNameAtoZ = (groups: Array<GroupModel>) => {
  const sortedList = groups.slice().sort((a, b) => {
    const aName = a?.groupName
    const bName = b?.groupName

    return aName.localeCompare(bName)
  })

  return sortedList
}
export const filterGroupsNumberOfMembersHighToLow = (groups: Array<GroupModel>) => {
  const sortedList = groups.slice().sort((a, b) => {
    const aNumberOfMembers = a?.members.length ?? 0
    const bNumberOfMembers = b?.members.length ?? 0
    return bNumberOfMembers - aNumberOfMembers
  })

  return sortedList
}
export const filterGroupsNumberOfMembersLowToHigh = (groups: Array<GroupModel>) => {
  const sortedList = groups.slice().sort((a, b) => {
    const aNumberOfMembers = a?.members.length ?? 0
    const bNumberOfMembers = b?.members.length ?? 0
    return aNumberOfMembers - bNumberOfMembers
  })

  return sortedList
}

//Filter suborgs
export const filterSuborgsNameZtoA = (suborgs: Array<OrganizationType>) => {
  const sortedList = suborgs.slice().sort((a, b) => {
    const aName = a?.name
    const bName = b?.name

    return bName.localeCompare(aName)
  })

  return sortedList
}
export const filterSuborgsNameAtoZ = (suborgs: Array<OrganizationType>) => {
  const sortedList = suborgs.slice().sort((a, b) => {
    const aName = a?.name
    const bName = b?.name

    return aName.localeCompare(bName)
  })

  return sortedList
}
export const filterSuborgNumberOfMembersHighToLow = (suborgs: Array<OrganizationType>) => {
  const sortedList = suborgs.slice().sort((a, b) => {
    const aNumberOfMembers = a?.stats?.members ?? 0
    const bNumberOfMembers = b?.stats?.members ?? 0
    return bNumberOfMembers - aNumberOfMembers
  })

  return sortedList
}
export const filterSuborgNumberOfMembersLowToHigh = (suborgs: Array<OrganizationType>) => {
  const sortedList = suborgs.slice().sort((a, b) => {
    const aNumberOfMembers = a?.stats?.members ?? 0
    const bNumberOfMembers = b?.stats?.members ?? 0
    return aNumberOfMembers - bNumberOfMembers
  })

  return sortedList
}
export const filterSuborgNumberOfGroupsHighToLow = (suborgs: Array<OrganizationType>) => {
  const sortedList = suborgs.slice().sort((a, b) => {
    const aNumberOfMembers = a?.stats?.groups ?? 0
    const bNumberOfMembers = b?.stats?.groups ?? 0
    return bNumberOfMembers - aNumberOfMembers
  })

  return sortedList
}
export const filterSuborgNumberOfGroupsLowToHigh = (suborgs: Array<OrganizationType>) => {
  const sortedList = suborgs.slice().sort((a, b) => {
    const aNumberOfMembers = a?.stats?.groups ?? 0
    const bNumberOfMembers = b?.stats?.groups ?? 0
    return aNumberOfMembers - bNumberOfMembers
  })

  return sortedList
}
export const filterSuborgNumberOfTerminalsHighToLow = (suborgs: Array<OrganizationType>) => {
  const sortedList = suborgs.slice().sort((a, b) => {
    const aNumberOfMembers = a?.stats?.terminals ?? 0
    const bNumberOfMembers = b?.stats?.terminals ?? 0
    return bNumberOfMembers - aNumberOfMembers
  })

  return sortedList
}
export const filterSuborgNumberOfTerminalsLowToHigh = (suborgs: Array<OrganizationType>) => {
  const sortedList = suborgs.slice().sort((a, b) => {
    const aNumberOfMembers = a?.stats?.terminals ?? 0
    const bNumberOfMembers = b?.stats?.terminals ?? 0
    return aNumberOfMembers - bNumberOfMembers
  })

  return sortedList
}

//Other
export const getListOfAllDatplanIds = (dataplans: Array<DataPlanModel>) => {
  let ids: Array<string> = []
  dataplans.map((item) => ids.push(item.id))
  return ids
}

export const getAllSubOrgsIds = (org: OrganizationType) => {
  let ids: Array<string> = []
  org.childOrganizations?.edges?.map((item) => ids.push(item.id))
  return ids
}

export const searchReceipts = (receipts: Array<Receipt>, searchTerm: string) => {
  let filteredList: Array<Receipt> = []
  receipts.map(
    (item) => JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase()) && filteredList.push(item),
  )
  return filteredList
}

export const searchActivityLog = (activities: Array<any>, searchTerm: string) => {
  let filteredList: Array<any> = []
  activities.map(
    (item) => JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase()) && filteredList.push(item),
  )
  return filteredList
}

export enum TerminalSortings {
  terminalNameAsc = "terminalName",
  terminalNameDesc = "-terminalName",
  serialNumberAsc = "serialNumber",
  serialNumberDesc = "-serialNumber",
  dataPlanAsc = "dataPlan",
  dataPlanDesc = "-dataPlan",
  dataUsageAsc = "dataUsage",
  dataUsageDesc = "-dataUsage",
  subOrganizationAsc = "subOrganization",
  subOrganizationDesc = "-subOrganization",
}

//filter terminals
export const sortTerminalNameAtoZ = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.name ?? ""
    const bName = b?.name ?? ""

    return aName.localeCompare(bName)
  })

  return sortedList
}
export const sortTerminalNameZtoA = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.name ?? ""
    const bName = b?.name ?? ""

    return bName.localeCompare(aName)
  })

  return sortedList
}
export const sortTerminalDataPlanNameAtoZ = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.dataplan ?? ""
    const bName = b?.dataplan ?? ""

    return aName.localeCompare(bName)
  })

  return sortedList
}
export const sortTerminalDataPlanNameZtoA = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.dataplan ?? ""
    const bName = b?.dataplan ?? ""

    return bName.localeCompare(aName)
  })

  return sortedList
}
export const sortTerminalSuborgNameAtoZ = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.suborganization ?? ""
    const bName = b?.suborganization ?? ""

    return aName.localeCompare(bName)
  })

  return sortedList
}
export const sortTerminalSuborgNameZtoA = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.suborganization ?? ""
    const bName = b?.suborganization ?? ""

    return bName.localeCompare(aName)
  })

  return sortedList
}
export const sortTerminalsSerialNumberHighLow = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.serialNumber ?? ""
    const bName = b?.serialNumber ?? ""

    return aName.localeCompare(bName)
  })
  return sortedList
}
export const sortTerminalsSerialNumberLowHigh = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.serialNumber ?? ""
    const bName = b?.serialNumber ?? ""

    return bName.localeCompare(aName)
  })
  return sortedList
}
export const sortTerminalsDataUsageHighLow = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.dataUsage?.used ?? 0
    const bName = b?.dataUsage?.used ?? 0

    return aName - bName
  })
  return sortedList
}
export const sortTerminalsDataUsageLowHigh = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aName = a?.dataUsage?.used ?? 0
    const bName = b?.dataUsage?.used ?? 0

    return bName - aName
  })
  return sortedList
}
export const sortTerminalsGroupsHighLow = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aGroups = a?.groups?.length ?? 0
    const bGroups = b?.groups?.length ?? 0

    return aGroups - bGroups
  })

  return sortedList
}
export const sortTerminalsGroupsLowHigh = (terminals: Array<TerminalDataModel>) => {
  const sortedList = terminals?.slice().sort((a, b) => {
    const aGroups = a?.groups?.length ?? 0
    const bGroups = b?.groups?.length ?? 0

    return bGroups - aGroups
  })

  return sortedList
}
